export {default as MergeBanner} from './MergeBanner.connect';
